/**
 * Buying Guide Modal
 * Intercepts clicks on buying-guide links, loads the guide content
 * in a lightbox (desktop) or slide-up drawer (mobile).
 * No dependencies — vanilla JS.
 */
(function () {
  'use strict';

  var cache = {};
  var overlay = null;
  var bodyEl = null;

  /** Build the modal DOM (once, lazily) */
  function getOverlay() {
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.className = 'bgm-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<div class="bgm-container">' +
        '<div class="bgm-header">' +
          '<button class="bgm-close" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="bgm-body"></div>' +
      '</div>';

    document.body.appendChild(overlay);
    bodyEl = overlay.querySelector('.bgm-body');

    // Close: X button
    overlay.querySelector('.bgm-close').addEventListener('click', close);

    // Close: click backdrop
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    // Close: Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('bgm-open')) {
        close();
      }
    });

    return overlay;
  }

  /** Open the modal and load content from href */
  function open(href) {
    var m = getOverlay();
    bodyEl.innerHTML = '<div class="bgm-loading">Loading&hellip;</div>';
    m.classList.add('bgm-open');
    document.body.style.overflow = 'hidden';

    // Cached?
    if (cache[href]) {
      bodyEl.innerHTML = cache[href];
      return;
    }

    fetch(href)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Try selectors in order of specificity
        var content =
          doc.querySelector('.rte') ||
          doc.querySelector('.page-content') ||
          doc.querySelector('main .shopify-section') ||
          doc.querySelector('main');

        if (content) {
          cache[href] = content.innerHTML;
          bodyEl.innerHTML = content.innerHTML;
        } else {
          bodyEl.innerHTML =
            '<div class="bgm-error">Couldn\'t load the guide. ' +
            '<a href="' + href + '" target="_blank">Open in a new tab &rarr;</a></div>';
        }
      })
      .catch(function () {
        bodyEl.innerHTML =
          '<div class="bgm-error">Couldn\'t load the guide. ' +
          '<a href="' + href + '" target="_blank">Open in a new tab &rarr;</a></div>';
      });
  }

  /** Close the modal */
  function close() {
    if (overlay) {
      overlay.classList.remove('bgm-open');
      document.body.style.overflow = '';
    }
  }

  /**
   * Intercept clicks on buying guide links.
   * Uses event delegation so it works on dynamically-loaded content too.
   */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a');
    if (!link) return;

    var href = link.getAttribute('href') || '';

    // Match buying-guide links (relative or absolute)
    if (href.indexOf('buying-guide') === -1) return;

    // Don't intercept links inside the modal (like "Shop" buttons)
    if (link.closest('.bgm-overlay')) return;

    // Don't intercept links opened with modifier keys (new tab, etc.)
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;

    e.preventDefault();

    // Normalize to relative URL for caching
    var url = href;
    if (url.indexOf('http') === 0) {
      try { url = new URL(url).pathname; } catch (err) { /* keep as-is */ }
    }

    open(url);
  });
})();
